import './SentryIntegration';
import React from 'react';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import './main.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { setupGlobalErrorHandler } from './utils/globalErrorHandler';
import { checkAndClearEncryptedData } from './utils/dynamicImportHandler';

setupGlobalErrorHandler();
checkAndClearEncryptedData();

if (typeof window.global === 'undefined') {
  window.global = window;
}

import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

serviceWorker.unregister();
